import { CARD_ACTIONS, CARD_LIFECYCLE_STATE } from './cfs-card'

export const isCardDeactivatedOrLocked = (status) => {
  return CARD_LIFECYCLE_STATE.DEACTIVATED === status
}

const DEACTIVATED_OPERATION_METADATA_CHANGE_BILLING_ADDRESS = {
  name: 'UPDATE_CARD_DETAILS',
  subOperation: 'CHANGE_BILLING_ADDRESS',
  metadata: [
    {
      type: 'INPUT_DATA',
      attributes: [
        {
          name: 'BILLING_ADDRESS',
          dataType: 'STRING',
          required: true,
        },
      ],
    },
  ],
}

const DEACTIVATED_OPERATION_METADATA_UPDATE_CARD_VERIFICATION_CODE = {
  name: 'UPDATE_CARD_DETAILS',
  subOperation: 'UPDATE_CARD_VERIFICATION_CODE',
  metadata: [
    {
      type: 'INPUT_DATA',
      attributes: [
        {
          name: 'CARD_VERIFICATION_CODE',
          dataType: 'STRING',
          required: true,
        },
      ],
    },
  ],
}

const DEACTIVATED_OPERATION_METADATA_GET_FUNDING_OPTIONS = {
  name: 'FUNDING_OPTIONS',
  subOperation: 'GET_FUNDING_OPTIONS',
}

const DEACTIVATED_OPERATION_METADATA_SET_PIN = {
  name: 'PINS',
  subOperation: 'SET_PIN',
  metadata: [
    {
      type: 'INPUT_DATA',
      attributes: [
        {
          name: 'PIN',
          dataType: 'NUMBER',
          required: true,
          minimumThreshold: '4',
          maximumThreshold: '4',
        },
      ],
    },
  ],
}

export const DEACTIVATED_OPERATION_METADATA = {
  [CARD_ACTIONS.CHANGE_BILLING_ADDRESS]: DEACTIVATED_OPERATION_METADATA_CHANGE_BILLING_ADDRESS,
  [CARD_ACTIONS.UPDATE_CARD_VERIFICATION_CODE]: DEACTIVATED_OPERATION_METADATA_UPDATE_CARD_VERIFICATION_CODE,
  [CARD_ACTIONS.GET_FUNDING_OPTIONS]: DEACTIVATED_OPERATION_METADATA_GET_FUNDING_OPTIONS,
  [CARD_ACTIONS.SET_PIN]: DEACTIVATED_OPERATION_METADATA_SET_PIN,
}

export const cardSubOperationsThatCanBeLocked = Object.values(DEACTIVATED_OPERATION_METADATA).map(
  (v) => v.subOperation,
)
